import React from 'react';
import Loading from '../../../assets/images/loading.svg';

const Loader = ({ height = 32, width = 32 }) => {
  return (
    <div className="flex items-center justify-center flex-1 my-2 w-full">
      <img src={Loading} height={height} width={width} />
    </div>
  );
};

export default Loader;
